import textButton from './textButton';
export default textButton;



// WEBPACK FOOTER //
// ./src/components/textButton/index.js